import { applicationUrl } from 'shared/config/externalLinks'
import { copyTextToClipboard } from 'shared/lib/copyTextToTextClipboard/copyTextToTextClipboard'

export const applicationLinkCopiedMessage = 'Ссылка на MineCards скопирована'

export const copyApplicationLink = () => {
    copyTextToClipboard(applicationUrl)
    return applicationLinkCopiedMessage
}
